import {
  AuditLogRowShell,
  LogTimestampCell,
} from '@/features/AuditLogs/components/AuditLogsTable/AuditLogRowShell'
import {
  formatAction,
  formatResource,
  getStatusColor,
} from '@/features/AuditLogs/utils/auditLogUtils'
import type { AuditLogs } from '@/generated/http-clients/v3ApiSchemas'
import { Table, Text } from '@chakra-ui/react'

interface AuditLogRowProps {
  log: AuditLogs
  isSelected: boolean
  onClick: () => void
  showDate?: boolean // Whether to show full date or just time
}

export function AuditLogRow({
  log,
  isSelected,
  onClick,
  showDate = true,
}: Readonly<AuditLogRowProps>) {
  const action = formatAction(log.request_metadata)

  return (
    <AuditLogRowShell
      statusColor={getStatusColor(log.status)}
      isSelected={isSelected}
      onClick={onClick}
    >
      <LogTimestampCell timestamp={log.timestamp} showDate={showDate} />
      <Table.Cell>
        <Text fontSize="sm" fontWeight="medium" lineClamp="1">
          {log.user || '-'}
        </Text>
      </Table.Cell>
      <Table.Cell>
        <Text fontSize="sm" fontFamily="mono" lineClamp="1" title={action}>
          {action}
        </Text>
      </Table.Cell>
      <Table.Cell>
        <Text fontSize="sm" lineClamp="1" title={formatResource(log.resource)}>
          {formatResource(log.resource)}
        </Text>
      </Table.Cell>
    </AuditLogRowShell>
  )
}
